// getters
export const SUMMARY_LOADING = 'summaryLoading'
export const SUMMARY_ERROR = 'summaryError'
export const MISSED_OPP_LOADING = 'missedOppLoading'
export const MISSED_OPP_ERROR = 'missedOppError'
export const ACCOUNTS_LOADING = 'accountsLoading'
export const ACCOUNTS_ERROR = 'accountsError'
export const SUMMARY_RAS_BENEFIT = 'summaryRasBenefit'
export const SUMMARY_DIVIDENDS_PAID = 'summaryDividendsPaid'
export const SUMMARY_BENEFITS_CLAIMED_PCT = 'summaryBenefitsClaimedPct'
export const SUMMARY_TRANSACTIONS_PROCESSED = 'summaryTransactionsProcessed'
export const SUMMARY_TOTAL_MISSED_BENEFIT = 'summaryTotalMissedBenefit'
export const SUMMARY_PAYMENTS_BY_YEAR = 'summaryPaymentsByYear'
export const SUMMARY_PAYMENTS_BY_MONTH = 'summaryPaymentsByMonth'
export const SUMMARY_BENEFIT_BY_COUNTRY = 'summaryBenefitByCountry'
export const SUMMARY_HIGHEST_VALUE_ACCOUNTS = 'summaryHighestValueAccounts'

export const MISSED_OPP_MISSED_BENEFITS = 'missedOppMissedBenefits'
export const MISSED_OPP_PARTIAL_SERVICE_ACCOUNTS =
  'missedOppPartialServiceAccounts'
export const MISSED_OPP_BENEFITS_MISSED_PCT = 'missedOppBenefitsMissedPct'
export const MISSED_OPP_INCOMPLETE_TRANSACTIONS =
  'missedOppIncompleteTransactions'
export const MISSED_OPP_RAS_BENEFIT = 'missedOppRasBenefit'
export const MISSED_OPP_BY_YEAR = 'missedOppByYear'
export const MISSED_OPP_BY_MONTH = 'missedOppByMonth'
export const MISSED_OPP_BY_COUNTRY = 'missedOppByCountry'
export const MISSED_OPP_HIGHEST_VALUE_ACCOUNTS = 'missedOppHighestValueAccounts'

export const ACCOUNTS_LIST = 'accountsList'
export const TRANSACTIONS_EXPORT_LOADING = 'transactionsExportLoading'
export const TRANSACTIONS_EXPORT_ERROR = 'transactionsExportError'

// mutations
export const SET_SUMMARY_LOADING = 'setSummaryLoading'
export const SET_SUMMARY_ERROR = 'setSummaryError'
export const SET_SUMMARY_DATA = 'setSummaryData'
export const SET_MISSED_OPP_LOADING = 'setMissedOppLoading'
export const SET_MISSED_OPP_ERROR = 'setMissedOppError'
export const SET_MISSED_OPP_DATA = 'setMissedOppData'
export const SET_ACCOUNTS_LOADING = 'setAccountsLoading'
export const SET_ACCOUNTS_ERROR = 'setAccountsError'
export const SET_ACCOUNTS_DATA = 'setAccountsData'
export const SET_TRANSACTIONS_EXPORT_LOADING = 'setTransactionsExportLoading'
export const SET_TRANSACTIONS_EXPORT_ERROR = 'setTransactionsExportError'

// actions
export const FETCH_SUMMARY = 'fetchSummary'
export const FETCH_MISSED_OPPORTUNITIES = 'fetchMissedOpportunities'
export const FETCH_ACCOUNTS = 'fetchAccounts'
export const EXPORT_TRANSACTIONS = 'exportTransactions'
